import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer, useRef } from 'react';
import { Button, Modal, Radio, RadioGroup } from '@skbkontur/react-ui';
import { ValidationContainer } from '@skbkontur/react-ui-validations';
import { FieldWrapper } from '../FieldWrapper';
import { TrimmedInput } from '../TrimmedInput';
import classes from './BirthplaceModal.module.css';
const getDefaultState = (value) => {
    return {
        type: value?.type || 'standard',
        country: value?.country || '',
        region: value?.region || '',
        district: value?.district || '',
        settlement: value?.settlement || '',
        text: value?.text || '',
    };
};
const getBirthplaceDef = (state) => {
    const getValue = (value) => value.trim() || undefined;
    const country = getValue(state.country);
    const region = getValue(state.region);
    const district = getValue(state.district);
    const settlement = getValue(state.settlement);
    const text = getValue(state.text);
    if (!country && !region && !district && !settlement && !text) {
        return null;
    }
    return {
        type: state.type,
        country,
        region,
        district,
        settlement,
        text,
    };
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'changeType': {
            return {
                ...state,
                type: action.payload,
                text: '',
            };
        }
        case 'changeCountry': {
            return {
                ...state,
                country: action.payload,
            };
        }
        case 'changeRegion': {
            return {
                ...state,
                region: action.payload,
            };
        }
        case 'changeDistrict': {
            return {
                ...state,
                district: action.payload,
            };
        }
        case 'changeSettlement': {
            return {
                ...state,
                settlement: action.payload,
            };
        }
        case 'changeText': {
            return {
                ...state,
                text: action.payload,
            };
        }
    }
};
const getValidationInfo = (state, value) => {
    if (!state.text) {
        return null;
    }
    return value
        ? { message: 'Должно быть заполнено либо Город - Район - Регион - Страна, либо Место рождения' }
        : null;
};
export const BirthplaceModal = ({ value, onClose, onSubmit, onCancel, onValidationError, }) => {
    const [state, dispatch] = useReducer(reducer, getDefaultState(value));
    const refValidationContainer = useRef(null);
    const handleSubmit = async () => {
        const isValid = await refValidationContainer.current?.validate();
        if (!isValid) {
            onValidationError();
            return;
        }
        onSubmit(getBirthplaceDef(state));
    };
    return (_jsxs(Modal, { onClose: onClose, ignoreBackgroundClick: true, children: [_jsx(Modal.Header, { children: "\u041C\u0435\u0441\u0442\u043E \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F" }), _jsx(Modal.Body, { children: _jsxs(ValidationContainer, { ref: refValidationContainer, children: [_jsx(FieldWrapper, { labelClassName: classes.label, label: "\u0422\u0438\u043F", children: _jsxs(RadioGroup, { name: "birthplaceType", value: state.type, onValueChange: (payload) => { dispatch({ type: 'changeType', payload }); }, children: [_jsx(Radio, { value: "standard", children: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435" }), _jsx("br", {}), _jsx(Radio, { value: "special", children: "\u041E\u0441\u043E\u0431\u043E\u0435" }), _jsx("div", { className: classes.secondary, children: "\u041D\u0435 \u043F\u043E \u0441\u0445\u0435\u043C\u0435: \u041D\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442 \u2013 \u0420\u0430\u0439\u043E\u043D \u2013 \u0420\u0435\u0433\u0438\u043E\u043D \u2013 \u0421\u0442\u0440\u0430\u043D\u0430" })] }) }), _jsxs("div", { className: classes.wrap, children: [_jsxs("div", { className: classes.fields, children: [_jsx(FieldWrapper, { labelClassName: classes.label, label: "\u0413\u043E\u0440\u043E\u0434 / \u0441\u0435\u043B\u043E / \u0434\u0435\u0440\u0435\u0432\u043D\u044F / ...", children: _jsx(TrimmedInput, { width: 258, value: state.settlement, onValueChange: (payload) => { dispatch({ type: 'changeSettlement', payload }); }, validationInfo: getValidationInfo(state, state.settlement) }) }), _jsx(FieldWrapper, { labelClassName: classes.label, label: "\u0420\u0430\u0439\u043E\u043D", children: _jsx(TrimmedInput, { width: 258, value: state.district, onValueChange: (payload) => { dispatch({ type: 'changeDistrict', payload }); }, validationInfo: getValidationInfo(state, state.district) }) }), _jsx(FieldWrapper, { labelClassName: classes.label, label: "\u0420\u0435\u0433\u0438\u043E\u043D", children: _jsx(TrimmedInput, { width: 258, value: state.region, onValueChange: (payload) => { dispatch({ type: 'changeRegion', payload }); }, validationInfo: getValidationInfo(state, state.region) }) }), _jsx(FieldWrapper, { labelClassName: classes.label, label: "\u0421\u0442\u0440\u0430\u043D\u0430", children: _jsx(TrimmedInput, { width: 258, value: state.country, onValueChange: (payload) => { dispatch({ type: 'changeCountry', payload }); }, validationInfo: getValidationInfo(state, state.country) }) })] }), _jsx("div", { className: classes.description, children: _jsx("div", { className: classes.secondary, children: "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043C\u0435\u0441\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u0447\u0430\u0441\u0442\u0438 \u0438 \u043A\u0430\u0436\u0434\u0443\u044E \u0447\u0430\u0441\u0442\u044C \u0437\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u0443\u044E \u0441\u0442\u0440\u043E\u043A\u0443" }) })] }), state.type === 'special' && (_jsxs("div", { className: classes.wrap, children: [_jsx("div", { className: classes.fields, children: _jsx(FieldWrapper, { labelClassName: classes.label, label: "\u041C\u0435\u0441\u0442\u043E \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F", children: _jsx(TrimmedInput, { width: 258, value: state.text, onValueChange: (payload) => { dispatch({ type: 'changeText', payload }); }, validationInfo: getValidationInfo(state, '') }) }) }), _jsx("div", { className: classes.description, children: _jsx("div", { className: classes.secondary, children: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435, \u0435\u0441\u043B\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441" }) })] }))] }) }), _jsxs(Modal.Footer, { panel: true, gap: 8, children: [_jsx(Button, { onClick: handleSubmit, use: "primary", size: "medium", children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }), _jsx(Button, { onClick: onCancel, size: "medium", children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })] })] }));
};
